const initialState = () => ({
  stateIS: "",
  qr_cus: "",
  qr_car: "",
  qr_peron: "",
});

const state = initialState();

const getters = {
  GET_STATEIS: (state) => state.stateIS,
  GET_CUS: (state) => state.qr_cus,
  GET_CAR: (state) => state.qr_car,
  GET_PERSON: (state) => state.qr_peron,
};

const mutations = {
  SET_ALL_ELEMENT(state, data) {
    state.qr_cus = Object.assign({}, data);
  },
  MERGE_ALL_ELEMENT(state, data) {
    let object1 = state.qr_cus;
    state.qr_cus = Object.assign(object1, data);
  },
  SET_ELEMENT_CUS(state, data) {
    state.qr_cus = data;
  },
  SET_ELEMENT_CAR(state, data) {
    state.qr_car = data;
  },
  SET_ELEMENT_PRESON(state, data) {
    state.qr_peron = data;
  },
  SET_STATEIS(state, data) {
    state.stateIS = data;
  },
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  reset({ commit }) {
    commit("RESET");
  },
};
// Mutations

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
